import { AppAlert, AppButton, AppTextLink } from '@9b3kuq5phwuk4txw/kiban-react-ui'
import { Label, Switch } from '@9b3kuq5phwuk4txw/kiban-react-ui/primitives'
import { EmailInput } from './-components/EmailInput'
import { PasswordInput } from './-components/PasswordInput'
import { usePasswordLogin } from './-hooks/usePasswordLogin'

interface PasswordTabProps {
  redirectPath?: string
}

/**
 * Passwordタブコンポーネント
 * メールアドレスとパスワードによる認証のUIとログイン処理を提供
 */
export function PasswordTab({ redirectPath }: PasswordTabProps) {
  const {
    email,
    setEmail,
    password,
    setPassword,
    persisted,
    setPersisted,
    setEmailValid,
    setPasswordValid,
    formValid,
    loading,
    invalidPassword,
    handleLoginClick,
  } = usePasswordLogin({ redirectPath })

  return (
    <div className='space-y-4'>
      <EmailInput value={email} onChange={setEmail} onValidChange={setEmailValid} />

      <PasswordInput
        value={password}
        onChange={setPassword}
        onValidChange={setPasswordValid}
        onEnter={handleLoginClick}
      />

      <div className='flex items-center justify-between'>
        <div className='flex items-center space-x-2'>
          <Switch id='persisted' checked={persisted} onCheckedChange={setPersisted} />
          <Label htmlFor='persisted' className='text-sm cursor-pointer'>
            ログイン状態を維持
          </Label>
        </div>

        <AppButton onClick={handleLoginClick} disabled={!formValid || loading} className='min-w-25'>
          ログイン
        </AppButton>
      </div>

      {invalidPassword && (
        <AppAlert type='error'>
          <p>ログインIDもしくはパスワードが間違っています</p>
        </AppAlert>
      )}

      <AppAlert type='info'>
        <div className='space-y-2'>
          <div className='flex flex-row space-x-1'>
            <p>パスワードを忘れた際は</p>
            <AppTextLink
              href='https://teams.microsoft.com/l/channel/19%3af85cacf806c8475e824c85ae3e6e0b32%40thread.tacv2/98_%25E3%2582%25A2%25E3%2582%25AB%25E3%2582%25A6%25E3%2583%25B3%25E3%2583%2588%25E7%2599%25BA%25E8%25A1%258C%25E3%2583%25BBPW%25E5%2586%258D%25E7%2599%25BA%25E8%25A1%258C%25E4%25BE%259D%25E9%25A0%25BC?groupId=128db2a0-1bc5-4b32-aa59-88a3087deb3f&tenantId=1aa34c22-0ed5-47cd-aa30-c11bce319d95'
              external
            >
              Teamsチャネル
            </AppTextLink>
            <p>より再発行依頼ください</p>
          </div>
          <p>※Teamsに参加する際は所属G長から申請をお願いします</p>
        </div>
      </AppAlert>
      <AppAlert type='info'>
        <p>新規アカウント発行希望の方は所属G長より依頼ください</p>
      </AppAlert>
    </div>
  )
}
